var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "supportConfirm" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [
        _vm._v("お問い合わせ内容確認")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("section", { staticClass: "support_section" }, [
                _c("div", { staticClass: "support_confirm_area" }, [
                  _c("div", [
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _c("div", { staticClass: "confirm_label" }, [
                            _vm._v(_vm._s(_vm.label.supportTitle))
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.supportData.supportTitle, function(
                            support
                          ) {
                            return _c("div", { key: support }, [
                              _c("div", { staticClass: "confirm_text" }, [
                                _vm._v(_vm._s(support))
                              ])
                            ])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "confirm_label" }, [
                          _vm._v(_vm._s(_vm.label.supportBody))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "confirm_text" }, [
                          _vm._v(_vm._s(_vm.supportData.supportBody))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "confirm_label" }, [
                          _vm._v(_vm._s(_vm.label.userName))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "confirm_text" }, [
                          _vm._v(
                            _vm._s(_vm.supportData.userLastName) +
                              " " +
                              _vm._s(_vm.supportData.userFirstName)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "confirm_label" }, [
                          _vm._v(_vm._s(_vm.label.userNameKana))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "confirm_text" }, [
                          _vm._v(
                            _vm._s(_vm.supportData.userLastNameKana) +
                              " " +
                              _vm._s(_vm.supportData.userFirstNameKana)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "confirm_label" }, [
                          _vm._v(_vm._s(_vm.label.tel))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "confirm_text" }, [
                          _vm._v(_vm._s(_vm.supportData.tel))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("div", { staticClass: "confirm_label" }, [
                          _vm._v(_vm._s(_vm.label.email))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "confirm_text" }, [
                          _vm._v(_vm._s(_vm.supportData.email))
                        ])
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control_btn_area" }, [
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn2",
                      on: {
                        click: function($event) {
                          _vm.goBack()
                        }
                      }
                    },
                    [_vm._v("戻る")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn2 btn_color",
                      on: {
                        click: function($event) {
                          _vm.complete()
                        }
                      }
                    },
                    [_vm._v("送信")]
                  )
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e8dce2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8dce2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcSupportConfirm.vue
// module id = null
// module chunks = 